import classNames from 'classnames';
import { LoaderLogo } from './LoaderLogo';
import { useSiteColors } from '../../../../hooks/useSiteColors';
import { DEFAULT_PRIMARY_COLOR } from '../../../../constants';
// import { Color } from "../../../../context/theme/ThemeConstants";

const DefaultMainLine = 'ReferralBook';
const DefaultTagLine = 'Create. Share. Earn.';

export const AppLoader = (props: Props) => {
  const { lowerZ, excludeFade } = props;
  const mainline = props.mainline || DefaultMainLine;
  const tagline = props.tagline || DefaultTagLine;
  // const colorOverride = Color.yellow;
  // const colorOverride = Color.orange;
  // const colorOverride = Color.red;
  // const colorOverride = Color.pink;
  // const colorOverride = Color.fuchsia;
  const backgroundOnly = false;

  useSiteColors(DEFAULT_PRIMARY_COLOR, DEFAULT_PRIMARY_COLOR, DEFAULT_PRIMARY_COLOR);

  return (
    <div className={classNames('fixed left-0 top-0 h-screen w-screen bg-blue-100', lowerZ ? 'z-20' : 'z-50')}>
      {!backgroundOnly && (
        <div className="abs-middle flex flex-col items-center justify-center">
          <LoaderLogo excludeFade={excludeFade} mainline={mainline} tagline={tagline} isMobile />
          <LoaderLogo excludeFade={excludeFade} mainline={mainline} tagline={tagline} />
        </div>
      )}
    </div>
  );
};

type Props = {
  lowerZ?: boolean;
  excludeFade?: boolean;
  mainline?: string;
  tagline?: string;
};
